import { render, staticRenderFns } from "./CovidHp.vue?vue&type=template&id=e902a8aa&"
import script from "./CovidHp.vue?vue&type=script&lang=js&"
export * from "./CovidHp.vue?vue&type=script&lang=js&"
import style0 from "./CovidHp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports